// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"0b6258c2","237":"2069b682","655":"e0b850e5","729":"0213e935"}[chunkId] + ".chunk.js";
};